import { helper } from '@ember/component/helper';

export function metricsFormattedLabel([label]: [string]) {
  return label.charAt(0).toUpperCase() + label.slice(1).replace(/_/g, ' ');
}

export default helper(metricsFormattedLabel);
